module.exports = __webpack_public_path__ + "static/media/visa.eb9f5c65.svg";